export default __webpack_public_path__ + "static/media/640_dummy2016-diy01-mobile-de.ad11cf02.png";